import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { getNotificationsRequest, updateSeenNotificationRequest } from '../Api/Notification';
import notification from "../Actions/notification";
const { setNotificationsData } = notification.actions;

export function* getNotificationsList({data}) {
    try {
        const response = yield call(getNotificationsRequest, data);
        if (response && response.status === 'success') {
            yield put(setNotificationsData(response.data));
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } 
}

export function* markNotificationAsSeen({notificationId, pagination}) {
    try {
        const response = yield call(updateSeenNotificationRequest, notificationId);
        if (response && response.status === 'success') {
            const response = yield call(getNotificationsRequest, pagination);
        if (response && response.status === 'success') {
            yield put(setNotificationsData(response.data));
        } else {
            message.error(response.message, 5);
        }
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    }
}

export function* notificationSaga() {    
    yield takeEvery(notification.types.GET_NOTIFICATIONS, getNotificationsList);
    yield takeEvery(notification.types.SEEN_NOTIFICATION, markNotificationAsSeen);
}